'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowTimeoutOverride = exports.rewriteUrl = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _core = require('./core');

var _url = require('../helpers/url');

var _update = require('../helpers/update');

var rewriteUrl = exports.rewriteUrl = function rewriteUrl(options) {
  return (0, _core.withUrl)(function (url) {
    var patternsRaw = options.localStorage && options.localStorage.getItem('URL_REWRITE');
    if (!patternsRaw) return url;
    var parsedPatterns = JSON.parse(patternsRaw);
    if (!Array.isArray(parsedPatterns)) {
      // eslint-disable-next-line no-console
      console.error('REWRITE_URL local storage key must be a stringified array');
      return url;
    }

    if (!parsedPatterns.length) return url;

    var urlString = (0, _url.buildUrl)(url);
    if (typeof parsedPatterns[0] === 'string' || parsedPatterns[0] instanceof String) {
      parsedPatterns = [parsedPatterns];
    }

    parsedPatterns.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          pattern = _ref2[0],
          replacement = _ref2[1];

      urlString = urlString.replace(new RegExp(pattern), replacement);
    });

    return (0, _url.parseUrl)(urlString);
  })(options);
};

var TIMEOUT_OVERRIDE_KEY = 'HUB-HTTP_TIMEOUT';

var allowTimeoutOverride = exports.allowTimeoutOverride = function allowTimeoutOverride(options) {
  var timeoutOverride = options.localStorage && options.localStorage.getItem(TIMEOUT_OVERRIDE_KEY);
  if (timeoutOverride != null) {
    // eslint-disable-next-line no-console
    console.log('[hub-http] Using localStorage override ' + TIMEOUT_OVERRIDE_KEY + ' for request timeout.');
    return (0, _update.set)('timeout', parseInt(timeoutOverride))(options);
  }

  return options;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.179/js/middlewares/debug.js
// module id = 245
// module chunks = 2 3